module.exports = __webpack_public_path__ + "static/media/TS.404e9c4a.png";